import { useEffect, useState } from "react"
import BuildingBlocksDTO, { TrainerGantt90Schema } from "../../DTO/BuildingBlocksDTO"
import { EventDTO } from "../../DTO/EventDTO"
import './TrainersGantt90.scss'
import AvailablityDTO from "../../DTO/AvailablityDTO"
import { Status } from "../day/dayView"
import Spinner from "../../../components/Spinner/Spinner"
import { Button, ButtonGroup } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';

export default function TrainersGantt90(props: {
  buildingBlocksDTO: BuildingBlocksDTO,
  items: EventDTO[],
  page: number,
  startDate: Date | null,
}) {
  const [items, setItems] = useState<TrainerGantt90Schema>()
  const [status, setStatus] = useState(Status.loading)
  const [markerA, setMarkerA] = useState([-1, -1])
  const [markerB, setMarkerB] = useState([-1, -1])
  const [markerState, setMarkerState] = useState(0)
  const [timeline] = useState(new AvailablityDTO({}))
  useEffect(() => {
    const items = props.items
    if (items.length === 0) { return }
    setStatus(Status.loading)
    props.buildingBlocksDTO.getTrainersGantt90(items, timeline).then((result) => {
      if (result.rows.length > 0) {
        setItems(result)
      }
      setStatus(Status.standard)
    })
  }, [timeline, props.buildingBlocksDTO, props.items])

  function isInMarkedArea(x: number, y: number): boolean {
    if (markerA[0] !== -1 && markerB[0] !== -1 && markerA[1] !== -1 && markerB[1] !== -1 && markerA[0] !== x) {
      return false
    }
    if (!((markerA[1] <= y && y <= markerB[1]) || (markerB[1] <= y && y <= markerA[1]))) {
      return false
    }
    return true
  }
  function isMarkedAreaClass(x: number, y: number) {
    if (!isInMarkedArea(x, y)) {
      return ''
    }
    let out = ' markedArea'
    if (markerA[1] === y && markerB[1] > y) {
      out += ' markedAreaTop'
    }
    if (markerA[1] < y && markerB[1] === y) {
      out += ' markedAreaBottom'
    }
    return out
  }
  function markCell(x: number, y: number) {
    if (isInMarkedArea(x, y)) {
      setMarkerA([-1, -1])
      setMarkerB([-1, -1])
      setMarkerState(0)
      return
    }
    if (markerState === 0 || markerA[0] !== x) {
      setMarkerA([x, y])
      setMarkerB([x, y])
      setMarkerState(1)
    } else {
      setMarkerB([x, y])
      setMarkerState(0)
    }
  }
  function createAvailablity(tagId: number) {
    // Diese Funktion muss nun anhand der Koordinaten den Datumsbereich und der User herausfinden:
    // Start und Enddatum finden
    const timeA = items?.rows[markerA[1]].cells[markerA[0]].dateKey
    const timeB = items?.rows[markerB[1]].cells[markerB[0]].dateKey
    if (!timeA || !timeB) {
      return
    }
    const trainerId = items?.headers[markerA[0]].trainerId
    const dateRange = [new Date(timeA), new Date(timeB)].sort((a,b) => a.getTime() - b.getTime())
    timeline.createAvailablity(trainerId || -1, dateRange, tagId).then((result) => {
      if (result.code === false) {
        switch(result.key) {
          case 'vacationExistsInInterval':
            alert('Es existiert bereits ein Urlaub in diesem Zeitraum')
        }
      }
      // TODO - Inhalt neu rendern!
    })
  }

  async function deleteVacation(personId: number, dateKey: string) {
    await timeline.deleteItemByPersonDate(personId, new Date(dateKey))
    props.buildingBlocksDTO.getTrainersGantt90(props.items, timeline).then((result) => {
      setItems(result)
      setStatus(Status.standard)
    })
  }

  return (
    <>
      {
        status === Status.loading && <Spinner />
      }
      <table className='TrainersGantt90'>
        <thead>
          <tr>
            <th>KW</th>
            <th
              className="w3-padding"
            >Datum</th>
            {
              items?.headers.map((item, index) => {
                return <th
                  key={item.key}
                  title={item.name}
                  className={'TrainersGantt90name'}
                >
                  <button className="w3-button" onClick={item.onClick}>{item.name}</button>
                </th>
              })
            }
          </tr>
        </thead>
        <tbody>
          {
            items?.rows.map((item, yindex) => {
              return <tr
                key={item.key}
                className={item.className}
              >
                <td className="w3-center">{item.calendarWeek}</td>
                <td className="w3-center theDate">{item.name}</td>
                {
                  item.cells.map((cell, xindex) => {
                    return <td
                      key={xindex}
                      className={cell.className + isMarkedAreaClass(xindex, yindex)}
                      onClick={() => {
                        markCell(xindex, yindex)
                      }}
                      style={{
                        backgroundColor: cell.bgColor
                      }}
                    > 
                      <div className={`TrainerGanttHoverDisplay ${cell.className}`}>
                        <b>{cell.name}</b>
                        <p className="w3-margin-top w3-margin-bottom">{item.weekdayName} {cell.displayName}</p>
                        {
                          isInMarkedArea(xindex, yindex) &&
                          <>
                            <p className="w3-margin-top w3-margin-bottom">Eintragen:</p>
                            <ButtonGroup className="w3-margin-bottom" orientation="vertical" aria-label="Vertical button group">
                              {
                                timeline.filterByTags.getTags().map((tag, index) => {
                                  return <Button
                                    key={`createVacationButton-${tag.id}-${xindex}-${yindex}`}
                                    variant="outlined"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      createAvailablity(tag.id)
                                    }}
                                  >{tag.name}</Button>
                                })
                              }
                            </ButtonGroup>
                          </>
                        }
                        {
                          cell.name !== '' &&
                          <Button
                            startIcon={<DeleteIcon/>}
                            onClick={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              deleteVacation(cell.personId, cell.dateKey)
                            }}
                            variant="outlined"
                          >{cell.name} löschen</Button>
                        }
                        {
                          cell.hoverContent.map((hoverContent, index) => {
                            return <button
                              key={index}
                              className={`w3-button allowLineBreak ${hoverContent.className}`}
                              onClick={hoverContent.onClick}
                            >
                              {hoverContent.displayName}
                            </button>
                          })
                        }
                      </div>
                    </td>
                  })
                }
              </tr>
            })
          }
        </tbody>
      </table>
    </>
  )
}
